import { NavBar } from 'components/NavBar/NavBar'
import { isSameDay, startOfWeek } from 'date-fns'
import { useMemo, useState } from 'react'
import { Animation, ColoredDot, darkTheme, Flex, H1WithBack, lightTheme, PageWrapper, StyledContainer, TablesGrid, Tabs, TabsContainer, TextRowSeparator, } from 'styling/GlobalStyles'
import { convertMinsToHrsMins, formatDateForDisplay, formatNumbersForDisplay } from 'utils/helpers'
import { BasicInfoSectionScrollContainer, DashboardRangePicker, DashboardRewardPointsContainer, DBSingleEmployeeSection, EmployeePicture, EmployeeSchedulecContainer, NoAvailableData, ScheduleCard, SingleDBEmployeeTopSection } from '../Dashboard.styled'
import Avatar from '../../../assets/images/profileAvatar.png'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { useParams } from 'react-router-dom'
import { clearSingleDBEmployee, getSingleDBEmployee } from 'features/dashboard/dbEmployeesSlice'
import { taskStatusesData } from '../dashboardData'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import useQueryPagination from 'hooks/useQueryPagination'
import { BodyText, Head1, Head2, Head4, OtherText } from 'styling/Typography'
import { SmallTable, SmallThead } from 'components/SmallTable/SmallTable.styled'
import { RadarChart } from 'components/Chart/RadarChart'
import { BarChart } from 'components/Chart/BarChart'
import { BigStar } from 'assets/icons/BigStar'
import { TopPerfomerBadge } from 'assets/icons/EmployeeBadges/TopPerformerBadge'
import { NeverLateBadge } from 'assets/icons/EmployeeBadges/NeverLateBadge'
import { SafetyStarBadge } from 'assets/icons/EmployeeBadges/SafetyStarBadge'
import { QualityChampionBadge } from 'assets/icons/EmployeeBadges/QualityChampionBadge'
import { IncidentFreeBadge } from 'assets/icons/EmployeeBadges/IncidentFreeBadge'
import { TaskMasterBadge } from 'assets/icons/EmployeeBadges/TaskMasterBadge'
import { HighEfficiencyBadge } from 'assets/icons/EmployeeBadges/HighEfficiencyBadge'
import { ZeroDowntimeBadge } from 'assets/icons/EmployeeBadges/ZeroDowntimeBadge'
import { PerfectAttendanceBadge } from 'assets/icons/EmployeeBadges/PerfectAttendanceBadge'
import { ReliableBadge } from 'assets/icons/EmployeeBadges/ReliableBadge'
import { dietaryPreferences } from 'pages/Food/foodData'
import { attendanceTypesOptions } from 'pages/Attendance/data'
import { educationLevelOptions } from 'pages/Employees/employeesData'

export const DBSingleEmployee = () => {
    const { id } = useParams()
    const { singleEmployee } = useSelector((state: RootState) => state.dbEmployees)
    const [active, setActive] = useState('Basic Info')
    const { darkMode } = useSelector((state: RootState) => state.globals)
    const params = useMemo(() => ({ userId: id }), [])
    useQueryPagination({ fetchFunctions: [getSingleDBEmployee], cleanUpFunctions: [clearSingleDBEmployee], params })

    const BasicInfoTab = () => {

        return <BasicInfoSectionScrollContainer>
            <Flex gap='50px' >
                <Flex width='100%' column >
                    <BodyText><span style={{ fontWeight: 'bold' }} >Username: </span> {singleEmployee?.basicInfo?.username}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Phone Number: </span> {singleEmployee?.basicInfo?.phoneNumber}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Sec. Phone Number: </span> {singleEmployee?.basicInfo?.secondaryPhoneNumber || '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Email: </span> {singleEmployee?.basicInfo?.email || '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >National ID: </span> {singleEmployee?.basicInfo?.nationalId}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Date of Birth: </span>{formatDateForDisplay(singleEmployee?.basicInfo?.dateOfBirth)}</BodyText>
                </Flex>
                <Flex width='100%' column >
                    <BodyText><span style={{ fontWeight: 'bold' }} >Nationality: </span> {singleEmployee?.basicInfo?.nationality}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Martial Status:</span> {singleEmployee?.basicInfo?.maritalStatus}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Emergency Contact: </span> {singleEmployee?.basicInfo?.emergencyContact?.name || '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Emer. Contact Number: </span> {singleEmployee?.basicInfo?.emergencyContact?.phoneNumber || '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Education level: </span>{singleEmployee?.basicInfo?.educationLevel ? educationLevelOptions.find(l => l.value == singleEmployee.basicInfo.educationLevel).label : '/'}</BodyText>
                </Flex>
            </Flex>
        </BasicInfoSectionScrollContainer>
    }

    const Welfare = () => {
        return <Flex width='100%' column >
            <BodyText><span style={{ fontWeight: 'bold' }} >Food: </span> {dietaryPreferences.find(p => p.value == singleEmployee?.welfare.dietaryPreferences)?.label || '/'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Food allowance internal: </span>GH₵  {formatNumbersForDisplay(singleEmployee?.welfare?.foodAllowanceInCompanyAmount) || '0'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Food allowance external: </span>GH₵  {formatNumbersForDisplay(singleEmployee?.welfare?.foodAllowanceOutCompanyAmount) || '0'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Transport allowance internal: </span>GH₵  {formatNumbersForDisplay(singleEmployee?.welfare?.transportationAllowanceInCompanyAmount) || '0'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Transport allowance external: </span>GH₵  {formatNumbersForDisplay(singleEmployee?.welfare?.transportationAllowanceOutCompanyAmount) || '0'}</BodyText>
        </Flex>
    }

    const Contract = () => {
        return <BasicInfoSectionScrollContainer>
            <Flex gap='50px' >
                <Flex width='100%' column >
                    <BodyText><span style={{ fontWeight: 'bold' }} >Start Date: </span> {singleEmployee?.contract?.startDate ? formatDateForDisplay(singleEmployee?.contract.startDate) : '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Salary: </span>GH₵ {formatNumbersForDisplay(singleEmployee?.contract?.salary) ?? '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Work Schedule Model: </span> {singleEmployee?.contract?.workScheduleModelName || '/'}</BodyText>
                </Flex>
                <Flex width='100%' column >
                    <BodyText><span style={{ fontWeight: 'bold' }} >End Date: </span> {singleEmployee?.contract?.endDate ? formatDateForDisplay(singleEmployee?.contract.endDate) : '/'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Overtime: </span> {singleEmployee?.contract?.overtime ? 'Yes' : 'No'}</BodyText>
                    <TextRowSeparator />
                    <BodyText><span style={{ fontWeight: 'bold' }} >Shifts:</span> {singleEmployee?.contract?.shifts?.join(', ') || '/'}</BodyText>
                </Flex>
            </Flex>
        </BasicInfoSectionScrollContainer>
    }

    const BankInfo = () => {
        return <Flex width='100%' column >
            <BodyText><span style={{ fontWeight: 'bold' }} >SSNIT: </span> {singleEmployee?.bankInfo?.ssnit || '/'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Bank Name: </span> {singleEmployee?.bankInfo?.bankName || '/'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Branch Name: </span> {singleEmployee?.bankInfo?.branchName || '/'}</BodyText>
            <TextRowSeparator />
            <BodyText><span style={{ fontWeight: 'bold' }} >Account Number: </span> {singleEmployee?.bankInfo?.accountNumber || '/'}</BodyText>
        </Flex>
    }

    const renderTabs = () => {
        if (active == 'Basic Info') {
            return <BasicInfoTab />
        } else if (active == 'Welfare') {
            return <Welfare />
        } else if (active == 'Contract') {
            return <Contract />
        } else {
            return <BankInfo />
        }
    }


    const Schedule = ({ date, name, range, color }) => {
        function formatDateShort(date: Date): string {
            const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

            const dayAbbr = days[date.getDay()];
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based

            return `${dayAbbr} ${day}.${month}.`;
        }

        return <Flex gap='10px' column width='100px' minWidth='100px' >
            <OtherText  >{formatDateShort(date)}</OtherText>
            <ScheduleCard color={color ? '#' + color : null} null={!range}  >
                <OtherText weight='bold' >{name}</OtherText>
                <OtherText  >{range}</OtherText>
            </ScheduleCard>

        </Flex >
    }

    const data = [
        { value: 42, name: 'Monday' },
        { value: 35, name: 'Tuesday' },
        { value: 50, name: 'Wednesday' },
        { value: 28, name: 'Thursday' },
        { value: 60, name: 'Friday' },
        { value: 40, name: 'Saturday' },
        { value: 55, name: 'Sunday' },
    ]

    const RangePicker = () => {
        const [selected, setSelected] = useState('12 months')
        const options = ['12 months', '30 days', '7 days']
        const [open, setOpen] = useState(false)

        const handleSelect = (v: string) => {
            setSelected(v)
            setOpen(false)
        }

        return <DashboardRangePicker onClick={() => setOpen(true)} tabIndex={1} onBlur={() => setOpen(false)} >
            <OtherText>{selected}</OtherText>
            {open && <div className='dropdown' >
                {options.filter(o => o !== selected).map(o => <div onClick={() => handleSelect(o)} key={o} className='option' ><OtherText>{o}</OtherText></div>)}
            </div>}
        </DashboardRangePicker>
    }

    const attendance = attendanceTypesOptions.find(a => singleEmployee?.attendance.currentAttendance == 'Day off' ? a.label == 'Off Day' : a.label.toLowerCase() == singleEmployee?.attendance?.currentAttendance.toLowerCase())


    const renderSchedule = () => {
        const date = startOfWeek(new Date(), { weekStartsOn: 1 });
        const array = [];

        for (let i = 1; i <= 7; i++) {
            const currentDate = new Date(date); // kopija za ovu iteraciju

            const shiftForTheDay = singleEmployee?.shifts.find((s) => {
                return isSameDay(new Date(s.date), currentDate);
            });

            if (shiftForTheDay) {
                array.push({
                    date: new Date(shiftForTheDay.date),
                    shiftName: shiftForTheDay.shiftName,
                    color: shiftForTheDay.color,
                    range:
                        convertMinsToHrsMins(shiftForTheDay.shiftStart) +
                        '-' +
                        convertMinsToHrsMins(
                            shiftForTheDay.minutes,
                            shiftForTheDay.shiftStart
                        ),
                });
            } else {
                array.push({
                    date: currentDate, // koristi kopiju
                    shiftName: 'Not Set',
                    range: null,
                    color: null
                });
            }

            date.setDate(date.getDate() + 1); // pomeri za sledeći dan
        }

        return array;
    };

    return <>
        <NavBar />
        <Animation>
            <PageWrapper noFooter>
                <Flex between center>
                    <H1WithBack title='Employee Details' arrow />
                    {/* <Flex gap='1rem' center >
                        <EmployeeOfTheMonthBadge />
                        <Head5>Employee of <br />the Month</Head5>
                    </Flex> */}
                </Flex>
                <SingleDBEmployeeTopSection>
                    <Flex gap='1rem' height='100%' width='100%' center >
                        <EmployeePicture>
                            <img src={singleEmployee?.basicInfo?.profileImageUrl || Avatar} />
                        </EmployeePicture>
                        <Flex column between height='100%' width='100%' className='details' >
                            <Flex gap='13px' column>
                                <Head1 color='#ff9900' >{singleEmployee?.fullName}</Head1>
                                <Flex gap='1rem' center className='role' >
                                    <Head4>{singleEmployee?.roleName?.toUpperCase()}</Head4>
                                    <Flex gap='1rem' center >
                                        {singleEmployee?.attendance?.currentAttendance && attendance?.color && <ColoredDot color={darkMode ? darkTheme[attendance.color] : lightTheme[attendance.color]} />}
                                        <OtherText>{attendance?.label}</OtherText>
                                    </Flex>
                                </Flex>
                            </Flex>

                            <EmployeeSchedulecContainer >
                                {renderSchedule().map((s, i) => <Schedule color={s.color} date={s.date} name={s.shiftName} range={s.range} key={i} />)}
                            </EmployeeSchedulecContainer>
                        </Flex>
                    </Flex>
                    <Flex column between height='100%' style={{ minWidth: 300, maxWidth: 380, width: '100%' }} >
                        <Flex between width='100%' >
                            <Flex between center gap='1rem' width='100%'  >
                                <DashboardRewardPointsContainer><BodyText weight='bold' color='#333333' >{singleEmployee?.totalRewardPoints || 0} REWARD POINTS</BodyText></DashboardRewardPointsContainer>
                                <Flex center gap='1rem' ><BigStar /><Head1>{singleEmployee?.rating || '/'}</Head1></Flex>
                            </Flex>
                        </Flex>
                        <Flex between width='100%' >
                            <TopPerfomerBadge active={false} />
                            <NeverLateBadge active={false} />
                            <SafetyStarBadge active={false} />
                            <QualityChampionBadge active={false} />
                            <IncidentFreeBadge active={false} />
                        </Flex>


                        <Flex between width='100%'  >
                            <TaskMasterBadge active={false} />
                            <HighEfficiencyBadge active={false} />
                            <ZeroDowntimeBadge active={false} />
                            <PerfectAttendanceBadge active={false} />
                            <ReliableBadge active={false} />
                        </Flex>


                    </Flex>
                </SingleDBEmployeeTopSection>
                <TablesGrid style={{ rowGap: 12 }} >
                    <Flex column width='100%' center justcenter style={{ placeSelf: 'end' }}  >
                        <TabsContainer style={{ marginTop: 0 }} >
                            <Tabs active={active === 'Basic Info'} onClick={() => setActive('Basic Info')}>
                                Basic Info
                            </Tabs>
                            <Tabs active={active === 'Welfare'} onClick={() => setActive('Welfare')}>
                                Welfare
                            </Tabs>
                            <Tabs active={active === 'Contract'} onClick={() => setActive('Contract')}>
                                Contract
                            </Tabs>
                            <Tabs active={active === 'Bank Info'} onClick={() => setActive('Bank Info')}>
                                Bank Info
                            </Tabs>


                        </TabsContainer>
                        <DBSingleEmployeeSection>
                            {renderTabs()}
                        </DBSingleEmployeeSection>
                    </Flex>
                    <DBSingleEmployeeSection style={{ placeSelf: 'end' }} >
                        <NoAvailableData>
                            <Head2>NO AVAILABLE DATA</Head2>
                        </NoAvailableData>
                        <Flex height='100%' column gap='1rem' width='100%' >
                            <Flex width='100%' between center >
                                <Head4 color='#ff9900' >PERFOMANCE</Head4>
                                <RangePicker />
                            </Flex>
                            <BarChart data={data} showLabels percentage />
                        </Flex>

                    </DBSingleEmployeeSection>
                    <Flex column gap='1rem' >
                        <Flex gap='1rem' >
                            <StyledContainer width='155px' height='100px' >
                                <Flex column between height='100%' >
                                    <BodyText>Vacation used</BodyText>
                                    <Head2 color='#00B3FF' >{singleEmployee?.attendance?.vacationDaysUsed || '0'}/{singleEmployee?.attendance?.totalPossibleVacationDays || '0'}</Head2>
                                </Flex>
                            </StyledContainer>
                            <StyledContainer width='155px' height='100px' >
                                <Flex column between height='100%' >
                                    <BodyText>Days off</BodyText>
                                    <Head2 color='#FF342A' >{singleEmployee?.attendance?.daysOff || '0'}</Head2>
                                </Flex>

                            </StyledContainer>
                        </Flex>
                        <DBSingleEmployeeSection style={{ height: 'auto', minHeight: 240 }} >
                            <Flex width='100%' between center mb='16' >
                                <Head4 color='#ff9900' >LAST TASKS</Head4>
                                {/* <OtherText color='#ff9900' >View All</OtherText> */}
                            </Flex>
                            {singleEmployee?.lastFiveTasks.length ? <SmallTable>
                                <SmallThead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Status</th>
                                    </tr>
                                </SmallThead>

                                <tbody>
                                    {singleEmployee?.lastFiveTasks.slice(0, 4).map((t, i) => <tr key={i} >
                                        <td style={i == singleEmployee?.lastFiveTasks.slice(0, 4).length - 1 ? { paddingBottom: 0 } : {}} >{t.taskName}</td>
                                        <td style={i == singleEmployee?.lastFiveTasks.slice(0, 4).length - 1 ? { paddingBottom: 0 } : {}} >{taskStatusesData.find(s => s.id == t.taskStatus)?.name || '/'}</td>
                                    </tr>)}
                                </tbody>
                            </SmallTable> : <NoItems title='tasks' />}
                        </DBSingleEmployeeSection>
                    </Flex>

                    <Flex height='unset' width='100%' gap='1rem' >
                        <DBSingleEmployeeSection style={{ height: 'unset' }} >
                            <NoAvailableData>
                                <Head2>NO AVAILABLE DATA</Head2>
                            </NoAvailableData>
                            <Head4 color='#ff9900' >AI OBSERVATION</Head4>
                            <BodyText style={{ marginTop: '1rem' }} >Employee performance droped over the past 10 days. He was late on 30% of his tasks. And didn’t finish on time 20%</BodyText>
                        </DBSingleEmployeeSection>
                        <DBSingleEmployeeSection style={{ height: 'unset' }} >
                            <NoAvailableData>
                                <Head2>NO AVAILABLE DATA</Head2>
                            </NoAvailableData>
                            <Flex width='100%' between center mb='16' >
                                <Head4 color='#ff9900' >PRODUCTIVITY</Head4>
                                <RangePicker />
                            </Flex>
                            <Flex width='100%' height='100%' justcenter>
                                <RadarChart
                                    labels={['Efficiency', 'Speed', 'Safety', 'Reliability', 'Skills', 'Quality']}
                                    data={[4, 4, 2.5, 2, 5, 4]}
                                />
                            </Flex>
                        </DBSingleEmployeeSection>

                    </Flex>
                </TablesGrid>
            </PageWrapper>
        </Animation>
    </>
}